import React from "react";
import { useMaintenanceState } from "../Maintenance/Maintenance";

const VersionNumber = () => {
  const { data } = useMaintenanceState();

  if (data?.Version) {
    return (
      <div
        className="position-absolute fs-14"
        style={{ bottom: 16, right: 32 }}
      >
        V{data?.Version}
      </div>
    );
  } else {
    return <></>;
  }
};

export default VersionNumber;
